/**
 * 数据请求的唯一入口
 */

import sys from './sys/api'
import basedata from './basedata/api'
import event from './event/api'
import common from './common'
import general from './general/api'

export default {
    sys,
    basedata,
    event,
    common,
    general
}